const links = [
    {
        id: 1,
        url: '/',
        text: 'Domů',
    },
    {
        id: 2,
        url: '/porady',
        text: 'Pořady',
    },
    {
        id: 3,
        url: '/filmy',
        text: 'Filmy',
    },
    {
        id: 4,
        url: '/mujseznam',
        text: 'Můj seznam',
    },
]

export default links